import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zz3uf54cby: FaireBrandEntity = {
  token: "b_zz3uf54cby",
  type: "brand",
  name: "Ergodebrands",
  avatarUrl:
    "https://cdn.faire.com/fastly/674a3fbad8a3274d256026dff23eded218375e15ef1f311761bbaf6075d3be95.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/61b9b0069b9020a7ae932bf8f7a795eee599522ca8863e4ed7a554e4da91271a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/674a3fbad8a3274d256026dff23eded218375e15ef1f311761bbaf6075d3be95.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/61b9b0069b9020a7ae932bf8f7a795eee599522ca8863e4ed7a554e4da91271a.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 139,
  rating: 4.3,
  reviewCount: 11,
  isInsider: true,
  description: "",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:53:06.580Z",
    importedBy: "entity-db-cli",
  },
};
